import makeStyles from "@material-ui/core/styles/makeStyles";
import TextField from "@material-ui/core/TextField";
import CancelIcon from "@material-ui/icons/Cancel";
import Button from "@material-ui/core/Button";
import { useState } from "react";
import { useDataLayerValue } from "../../Reducer/DataLayer";

const Tags = () => {
  const classes = useStyles();

  const [{ tags }, dispatch] = useDataLayerValue();

  const [tag, setTag] = useState("");

  const handleTags = (index) => {
    dispatch({
      type: "ADD_TAG",
      payload: { tag, index },
    });
    setTag("");
  };

  return (
    <div className={classes.root}>
      <div className={classes.addTag}>
        <TextField
          label="Tag"
          placeholder="Add Tag under 20 words"
          className={classes.tag}
          variant="filled"
          value={tag}
          onChange={(e) => setTag(e.target.value)}
          multiline
        />
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.addButton}
          onClick={() => handleTags(-1)}
        >
          Add
        </Button>
      </div>
      <div className={classes.tagBox}>
        {tags?.map((tag, index) => (
          <div key={index} className={classes.tagContainer}>
            {tag}{" "}
            <CancelIcon
              variant="contained"
              onClick={() => handleTags(index)}
              className={classes.cutTag}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tags;

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#f2f4fc",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    margin: "3.5rem 0.125rem",
    borderRadius: "0.5rem",
  },
  addTag: {
    display: "flex",
    flex: 1,
    margin: "0.5rem 0.75rem",
  },
  tagBox: {
    display: "flex",
    flexWrap: "wrap",
    backgroundColor: "#d2d4d9",
    height: "7.5rem",
    margin: "0.5rem 1rem",
    padding: "0.1rem 0.1rem",
    borderRadius: "0.325rem",
    overflowY: "scroll",
    scrollBehavior: "smooth",
  },
  tag: {
    flex: 1,
    margin: "0.25rem 0.5rem",
    alignSelf: "center",
  },
  tagContainer: {
    backgroundColor: "#f0e6b9",
    borderRadius: "1rem",
    height: "2.125rem",
    margin: "0.075rem 0.125rem",
    padding: "0.25rem 0.25rem",
  },
  cutTag: {
    cursor: "pointer",
  },
  addButton: { alignSelf: "center" },
}));
